import { render, staticRenderFns } from "./PricingRatePlan.vue?vue&type=template&id=31d8c3a2&"
import script from "./PricingRatePlan.vue?vue&type=script&lang=js&"
export * from "./PricingRatePlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports